import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import styled from 'styled-components'
import { LOCATION_SELECTOR_TARGET_ID } from 'constant'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Input from 'components/common/FormElements/Input/Input'
import { formatPhoneNumber, normalizePhoneNumber } from 'helpers/phone-number'
import model from 'components/AppointmentConfirmationPage/AppointmentInfo/viewModel'
import { Col } from 'components/AppointmentConfirmationPage/AppointmentInfo/components/AppointmentInfo.styles'
import Section from '../../../Section'
import StepperActionBar from '../StepperActionBar'
import { SectionWrapper, ErrorMessage, ActionBarWrapper } from '../common'
import {
  CONTACT_INFORMATION,
  WAIT_DROPOFF_HEADER,
  CUSTOMER_HEADER_ID,
  WAIT_DROPOFF_HEADER_ID
} from 'components/AppointmentConfirmationPage/constants'
import {
  PHONE_HEADER_ID,
  EMAIL_HEADER_ID
} from 'components/AppointmentConfirmationPage/AppointmentInfo/constants'

import {
  CONTACT_INFO_TITLE,
  CONTACT_INFO_SUBHEAD
} from './constants'

const CustomInput = styled(Input)`
  width: 100%;

  & [data-error-message] {
    position: relative;
    top: 4px;
  }
`

const ContactInfo = ({ currentStepIndex, onPreviousStep, handleSubmit, error, submitFailed }) =>
  <form onSubmit={ handleSubmit }>
    <SectionWrapper>
      <CustomSection
        asset="contact-red"
        title={ CONTACT_INFO_TITLE }
        subhead={ CONTACT_INFO_SUBHEAD }
        targetId={ LOCATION_SELECTOR_TARGET_ID } >
        <Row>
          <fieldset>
            <legend><Media.ScreenReader>{ CONTACT_INFORMATION }</Media.ScreenReader></legend>
            <Headline id={ CUSTOMER_HEADER_ID } data-at-customer-header>
              To whom should we send your appointment information once confirmed?
            </Headline>
            <Col first>
              <Row>
                <Field { ...model.firstName } small full component={ CustomInput } />
              </Row>
            </Col>
            <Col>
              <Row>
                <Field { ...model.lastName } small full component={ CustomInput } />
              </Row>
            </Col>
            <Headline id={ PHONE_HEADER_ID } data-at-phone-header>
              We will contact you by phone to confirm your appointment at ...
            </Headline>
            <Col width="100%">
              <Field
                { ...model.phoneNumber }
                component={ CustomInput }
                formatValueDisplay={ formatPhoneNumber }
                normalize={ normalizePhoneNumber } />
            </Col>
            <Headline id={ EMAIL_HEADER_ID } data-at-email-header>
              We will email your appointment details to …
            </Headline>
            <Col width="100%">
              <Field { ...model.email } component={ CustomInput } />
            </Col>
          </fieldset>
          <Headline id={ WAIT_DROPOFF_HEADER_ID } data-at-wait-dropoff-header>
            Would you like to …
          </Headline>
        </Row>
        <ButtonsWrapper>
          <fieldset>
            <legend><Media.ScreenReader>{ WAIT_DROPOFF_HEADER }</Media.ScreenReader></legend>
            <SpanSpacer>
              <Field { ...model.userPlan.dropOff } component={ Input } />
            </SpanSpacer>
            <Field { ...model.userPlan.wait } component={ Input } />
          </fieldset>
        </ButtonsWrapper>
        <StyledActionBar>
          <StepperActionBar
            hasPrevPage
            hasNextPage
            isPrevPageVisible
            currentStepIndex={ currentStepIndex }
            prevPageClick={ onPreviousStep } />

          <ErrorMessage
            role="alert"
            aria-live="assertive"
            aria-label={ error }>
            { (submitFailed && error) || '' }
          </ErrorMessage>
        </StyledActionBar>
      </CustomSection>
    </SectionWrapper>

  </form>

ContactInfo.propTypes = {
  currentStepIndex: PropTypes.number,
  error: PropTypes.string,
  handleSubmit: PropTypes.func,
  onPreviousStep: PropTypes.func,
  submitFailed: PropTypes.bool
}

export default ContactInfo

const CustomSection = styled(Section)`
  ${Media.desktop`
    margin: 0 auto;
    width: 504px;
  `}
  ${Media.mobile`
    margin: 0;
  `}
`

const Row = styled.div`
  ${Mixin.clearFix()}
`

const Headline = styled.p`
  padding: 0 12px;
  clear: both;
  font-style: italic;
  color: ${Theme.colors.dark_grey};
  ${Mixin.font.GothamBold(14)}
  ${Media.mobile`
    padding: 0;
  `}
`

const ButtonsWrapper = styled.div`
  padding: 0 12px;
`

const SpanSpacer = styled.span`
  ${Mixin.responsive('margin-right', '32px', '16px')}
`

const StyledActionBar = styled(ActionBarWrapper)`
  ${Media.desktop`
    margin-left: 10px;
  `}
`
